const features = {
  SUPPORTS_CONTENT_MANAGEMENT: 'SupportsContentManagement',
  SUPPORTS_STUDENT_OUTREACH: 'SupportsStudentOutreach',
  SUPPORTS_STUDENT_ANALYTICS: 'SupportsStudentAnalytics',
  SUPPORTS_USER_UPLOADED_SEGMENTS: 'SupportsUserUploadedSegments',
  SUPPORTS_CRM_MATCHING_REPORT: 'SupportsCRMMatchReport',
  APPLICATION_INTEGRATION: 'ApplicationIntegration',
  APPLICATION_ACTIVATION: 'ApplicationActivation',
  CRM_INTEGRATION: 'CrmIntegration',
}

export default features
